var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"title"},[_vm._v("第一步：测评须知")]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.konwinfo)+" ")]),_c('div',{staticClass:"know",on:{"click":_vm.know}},[_vm._v("知道了")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }